// src/components/ui/textarea.js
import React from 'react';

const Textarea = React.forwardRef(({ 
  className = '', 
  error = false,
  rows = 3,
  ...props 
}, ref) => {
  const baseClasses = `
    flex min-h-[80px] w-full rounded-md border border-gray-300 
    bg-white px-3 py-2 text-sm 
    placeholder:text-gray-400
    focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent
    disabled:cursor-not-allowed disabled:opacity-50
    transition-colors resize-y
  `;

  const errorClasses = error ? 'border-red-500 focus:ring-red-500' : '';
  
  return (
    <textarea
      ref={ref}
      rows={rows}
      className={`${baseClasses} ${errorClasses} ${className}`.trim()}
      {...props}
    />
  );
});

Textarea.displayName = 'Textarea';

export { Textarea };